import {
  Backdrop,
  Button,
  CircularProgress,
  Stack,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

export interface MarketplaceWaitingOverlayProps {
  open: boolean;
  title: string;
  subtitle: string;
  detail?: string;
  onCancel?: () => void;
}

/** Overlay escuro + spinner — pagamento, vinculação de conta, etc. */
export function MarketplaceWaitingOverlay({
  open,
  title,
  subtitle,
  detail,
  onCancel,
}: MarketplaceWaitingOverlayProps) {
  const theme = useTheme();

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: theme.zIndex.modal + 20,
        flexDirection: "column",
        gap: 2,
        bgcolor: alpha(theme.palette.common.black, 0.72),
      }}
    >
      <CircularProgress size={52} thickness={4} sx={{ color: "common.white" }} />
      <Stack spacing={0.75} alignItems="center" sx={{ px: 3, maxWidth: 360 }}>
        <Typography
          sx={{
            ...mt.sectionTitle,
            color: "common.white",
            textAlign: "center",
          }}
        >
          {title}
        </Typography>
        {detail ? (
          <Typography
            sx={{ ...mt.bodySecondary, color: alpha("#fff", 0.85), textAlign: "center" }}
          >
            {detail}
          </Typography>
        ) : null}
        <Typography
          sx={{ ...mt.bodySecondary, color: alpha("#fff", 0.75), textAlign: "center" }}
        >
          {subtitle}
        </Typography>
      </Stack>
      {onCancel ? (
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            mt: 1,
            color: "common.white",
            borderColor: alpha("#fff", 0.4),
            textTransform: "none",
            ...mt.button,
            "&:hover": {
              borderColor: alpha("#fff", 0.7),
              bgcolor: alpha("#fff", 0.08),
            },
          }}
        >
          Cancelar
        </Button>
      ) : null}
    </Backdrop>
  );
}
